module.exports = __webpack_public_path__ + "static/media/missfortune.eed6aacc.png";